module.exports = __webpack_public_path__ + "static/media/eb_logo.28916542.png";


//////////////////
// WEBPACK FOOTER
// ./src/eb_logo.png
// module id = 626
// module chunks = 0